import { render, staticRenderFns } from "./NourishedNew.vue?vue&type=template&id=17ee5029&scoped=true&"
import script from "./NourishedNew.vue?vue&type=script&lang=js&"
export * from "./NourishedNew.vue?vue&type=script&lang=js&"
import style0 from "./NourishedNew.vue?vue&type=style&index=0&id=17ee5029&scoped=true&lang=scss&"
import style1 from "./NourishedNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee5029",
  null
  
)

export default component.exports